import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=b47ca8fa&scoped=true&"
import script from "./questionnaire.vue?vue&type=script&lang=js&"
export * from "./questionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47ca8fa",
  null
  
)

export default component.exports